const maintainColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    field: ['device', 'code'],
    width: 285
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    field: ['customer', 'company'],
    width: 480
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    field: ['device', 'model'],
    key: 'model'
  },
  {
    zh: '运行时间(h)',
    en: 'Runtime(h)',
    dataIndex: 'runTime',
    key: 'runTime'
  },
  {
    zh: '保养时间(h)',
    en: 'Maintain Time(h)',
    dataIndex: 'maintainTime',
    key: 'maintainTime'
  },
  {
    zh: '剩余天数',
    en: 'Leave Days',
    dataIndex: 'leaveDays',
    key: 'leaveDays'
  }
]

export default maintainColumns
